//#region imports
import React, { useEffect, useState, useRef } from 'react'

import useAuth from '../../auth/useAuth';
import { v4 as uuidv4 } from 'uuid';

import {
    settings, setSeparatorsNumbersNew, getItemStatsHtml, getDtRowIndex, getResponse, isUndNullNew, getLanguageObj, awaitDelay,
    LoadingSection, sendMessageCloseCurrentWindow, getError, getImageCircularGenericNew, getProcessButtons,
    isUndNullEmpNew,
} from '../../helpers/UtilsHelper';

import Swal from 'sweetalert2';

import ViewAllRates from '../rates/ViewAllRates';

import { setRatesVariations } from '../../helpers/rates/ratesHelper';
import ItemEdit from './ItemEdit';
import Menu from '../main/Menu';
import RateAddEdit from '../rates/RateAddEdit';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { RateClass } from '../../classes/rate/rateClass';
import { UserClass } from '../../classes/user/userClass';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { UserService } from '../../services/users/UserService';
import { RateService } from '../../services/rates/RateService';
import { ItemService } from '../../services/items/ItemService';
import TableIndex from '../main/TableIndex';
//#endregion imports

const $ = window.$;

const { app, colors, html, icons, messages, labels, firebase, numberPositions } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'Process - function';

export default function Process({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    let dataObj = {};

    const auth = useAuth();
    const selUsersId = 'selUsers';
    const [user, setUser] = useState(UserClass?.getClass());
    const [users, setUsers] = useState([]);
    const [process, setProcess] = useState({
        showLoading: false,
        selectUsers: false,
        btnSeeItems: false,
        btnSync: false,
        btnRateAdd: false,
        btnViewAllRates: false,
        btnCalculateRates: false,
    });
    const isMount = useRef(true);
    const [formData, setFormData] = useState(setFormDataDefault());
    const [isSelected, setIsSelected] = useState(false);
    let newPrice = 0.00;

    const [items, setItems] = useState([]);
    const dtItemsId = 'dtItems';
    const [dtItemsIndex, setDtItemsIndex] = useState(0);

    //#region variables item (Edit)
    const [itemEdited, setItemEdited] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertDelete, setShowAlertDelete] = useState(false);
    const [itemEditShowModal, setItemEditShowModal] = useState(false);
    //#endregion variables item (Edit)

    //#region Rates
    const dtRatesViewsId = 'dtRatesViews';
    const [rate, setRate] = useState(RateClass?.getClass());
    const [applyTo, setApplyTo] = useState(0);
    const [modalType, setModalType] = useState(0);
    const [rateViews, setRateViews] = useState([]);
    // const rateAddEditDateTimeId = 'rateAddEditDateTime';
    const [showModalRateAdd, setShowModalRateAdd] = useState(false);
    const [ratesViewShowModal, setRatesViewShowModal] = useState(false);
    //#endregion Rates
    //#endregion variables

    //#region item (process)
    function setFormDataDefault() {
        return {
            firstName: '',
            lastName: '',
            secondId: 0,
            email: '',
            rate: 0,
            items: 0,
        };
    }

    const setDataTable = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region Datatable

            //dtItemsMain = $(`#${dtItemsId}`).DataTable({
            $(`#${dtItemsId}`).DataTable({
                destroy: true,
                //data: items,
                data: [],
                order: [[7, 'asc']],
                columns: [
                    { title: labels?.image?.[languageObj?.id], width: '5%', orderable: false, },
                    { title: labels?.title?.[languageObj?.id], width: '40%', orderable: true, },
                    { title: labels?.status?.[languageObj?.id], className: 'text-center', width: '5%', orderable: true, },
                    { title: labels?.priceOC?.[languageObj?.id], className: 'text-right', width: '10%', orderable: true, },
                    { title: labels?.newPrice?.[languageObj?.id], className: 'text-right', width: '10%', orderable: true, },
                    { title: labels?.priceML?.[languageObj?.id], className: 'text-right', width: '10%', orderable: true, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, },
                    { title: 'Id', width: '5%', searchable: false, orderable: true, visible: false, },
                ],

                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtItemsId}_wrapper .col-md-6:eq(0)`);

            //#endregion Datatable

            //#region set query code
            response = setQueryCode({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return response;
            //#endregion set query code
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setDataClear = ({
        dtItems = false,
        subMethod = '',
    }) => {
        const currentMethod = 'setDataClear';
        let response = getResponse({ type: 0 });
        try {
            if (dtItems) {
                $(`#${dtItemsId}`).DataTable().rows().remove().draw(true);
            }
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let description = '';
            let methodValue = '';
            //#endregion variables

            //#region process
            $(`#${dtItemsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndex(dtItemsId, this, currentMethod)?.result;
                if (!isUndNullNew({ data: rowIndex, subMethod: currentMethod })?.result) {
                    methodValue = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodValue) {
                        case 'edit':
                            await getItemEdit({ id: id, description: description, rowIndex: rowIndex, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            setItems([]);

            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid, },
                ],
                ordersBy: [
                    { field: dbFields?.userName, value: dbOrdersBy?.asc, },
                ]
            };

            response = await UserService.getUsers({
                token: auth?.account?.tokenVzLaML?.token,
                data: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            setUsers(response?.result || []);

        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getUserAndRateByUserId = async ({
        userId = '',
        showMessage = true,
        subMethod = '',
    }) => {
        const currentMethod = 'getUserAndRateByUserId';
        let response = getResponse({ type: 0 });
        try {
            if (showMessage) {
                setProcess(prev => ({ ...prev, showLoading: true, selectUsers: true }));
            }

            //#region variables
            let user_ = UserClass?.getClass();
            let rate_ = RateClass?.getClass();
            setItems([]);
            //#endregion variables

            //#region clear dataTables
            response = setDataClear({
                dtItems: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion clear dataTable

            //#region process
            if (!isUndNullEmpNew({ data: userId, subMethod: currentMethod, })?.result) {
                //#region get user
                user_ = users.filter(({ id }) => id === userId)?.[0] || {};
                if (!isUndNullEmpNew({ data: user_, subMethod: currentMethod })?.result) {
                    user_ = user_?.[0] || user_;
                }
                //#endregion get user

                //#region check status user
                setIsSelected(true);
                setUser(user_);

                if (isUndNullNew({ data: user_?.code, subMethod: currentMethod, })?.result || user_?.secondId === 0) {
                    setIsSelected(false);
                    response = getResponse({ type: 1, msgText_: settings?.errors?.users?.newNotCode?.[languageObj?.id] });
                    return;
                }
                //#endregion check status user

                //#region get data (rates (last rate))
                dataObj = {
                    conditionals: [
                        { field: dbFields?.userId, operator: dbOperators?.equal, value: userId, },
                    ],
                    ordersBy: [
                        { field: dbFields?.register, value: dbOrdersBy?.desc, },
                    ],
                    limit: 1,
                };

                response = await RateService.getAll({
                    token: auth?.account?.tokenVzLaML?.token,
                    dataObj: dataObj,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) return;

                rate_ = response?.result?.[0] || {};
                setFormData({
                    ...formData,
                    firstName: user_?.firstName,
                    lastName: user_?.lastName,
                    email: user_?.email,
                    secondId: user_?.secondId,
                    rate: !isUndNullNew({ data: rate_?.rate, subMethod: currentMethod })?.result ? rate_?.rate : 0.00,
                });
                //#endregion get data (rates (last rate))
            } else {
                setFormData(setFormDataDefault());
                setIsSelected(false);
                setUser({});
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (showMessage) {
                setProcess(prev => ({ ...prev, showLoading: false, selectUsers: false }));
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getItemsByUser = async ({
        e = null,
        showProcessing = false,
        subMethod = '',
    }) => {
        const currentMethod = 'getItemsByUser';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let itemsLocal = [];
            let dtRows = [];
            let newPriceLocal = 0.00;
            setItems([]);
            //#endregion variables

            if (!isUndNullEmpNew({ data: e?.preventDefault, subMethod: currentMethod })?.result) {
                e?.preventDefault();
            }

            //#region process
            if (showProcessing) {
                setProcess(prev => ({ ...prev, showLoading: true, btnSeeItems: true }));
            }

            //#region clear dataTable
            response = setDataClear({
                dtItems: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion clear dataTable

            //#region get data (items / api / local)
            dataObj = {
                conditionals: [],
                ordersBy: [],
                method: settings?.mercadoLibre?.methods?.items?.itemsByUser,
                userId: user.id,
            };

            response = await ItemService.postQuery({
                token: auth?.account?.tokenVzLaML?.token,
                dataObj: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            itemsLocal = response?.result || [];

            if (isUndNullEmpNew({ data: itemsLocal, subMethod: currentMethod })?.result || itemsLocal.length <= 0) {
                response = getResponse({ type: 1, msgText_: messages?.noPublicationsYet?.[languageObj?.id] });
                return;
            }

            setItems(itemsLocal);
            //#endregion get data (items / api / local)

            //#region set data in dataTable
            itemsLocal?.forEach((item) => {
                newPriceLocal = getNewPrice({
                    priceOtherCurrency: item?.priceOtherCurrency,
                    rate: formData?.rate,
                    subMethod: currentMethod,
                });

                dtRows.push([
                    getImageCircularGenericNew({ alt: 'accountImage', src: item?.picture, subMethod })?.result,
                    item.title,
                    `${getItemStatsHtml({ data: item.status })}`,
                    `${setSeparatorsNumbersNew({ number: item.priceOtherCurrency, withDecimals: true, subMethod: currentMethod })?.result}`,
                    `${setSeparatorsNumbersNew({ number: newPriceLocal, withDecimals: true, subMethod: currentMethod })?.result} <i class='${setComparatorPrices({ newPrice_: newPriceLocal, price_: item?.price, subMethod: currentMethod })}'></i>`,
                    `${setSeparatorsNumbersNew({ number: item.price, withDecimals: true, subMethod: currentMethod })?.result}`,
                    getProcessButtons({
                        id: item.id,
                        description: item.title,
                        detailsShow: false,
                        detailsLabel: '',
                        detailsEnabled: false,
                        editShow: true,
                        editLabel: labels?.edit?.[languageObj?.id],
                        editEnabled: true,
                        deleteShow: false,
                        deleteLabel: '',
                        deleteEnabled: false,
                        processButtons: [],
                        languageId: languageObj?.id,
                        subMethod: currentMethod
                    })?.result,
                    item.itemId,
                ])
            });

            $(`#${dtItemsId}`).DataTable().rows.add(dtRows).draw(true);
            //#endregion set data in dataTable
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            if (showProcessing) {
                setProcess(prev => ({ ...prev, showLoading: false, btnSeeItems: false }));
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getNewPrice = ({
        priceOtherCurrency = 0.00,
        rate = 0.00,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getNewPrice';
        let response = getResponse({ type: 0 });
        try {
            newPrice = (priceOtherCurrency * rate).toFixed(numberPositions?.decimalsPlace);
            return newPrice;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.error(response);
            return 0.00;
        }
    }

    const setComparatorPrices = ({
        newPrice_ = 0.00,
        price_ = 0.00,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setComparatorPrices';
        let response = getResponse({ type: 0 });
        try {
            newPrice_ = parseFloat(newPrice_);
            price_ = parseFloat(price_);

            if (newPrice_ === price_) {
                return `${icons?.fasFa?.equals} text-primary`
            } else if (newPrice_ > price_) {
                return `${icons?.fasFa?.arrowUp} text-success`;
            } else if (newPrice_ < price_) {
                return `${icons?.fasFa?.arrowDown} text-warning`;
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.error(response);
            return '';
        }
    }

    const showCalculateRatesModal = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'showCalculateRatesModal';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            if (items.length <= 0) {
                response = getResponse({ type: 1, msgText_: messages?.thereIsNoDataToProcess?.[languageObj?.id] });
                return;
            }

            let swalProperties = SwalPropertiesClass?.getClass();
            swalProperties = {
                icon: settings.react.sweetAlert2.icons.warning,
                title: labels?.warning?.[languageObj?.id],
                html: `${messages?.itWillAutomaticallyCalculatePriceAnotherCurrency?.[languageObj?.id]}<br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                customClass: {
                    popup: settings?.html?.popup,
                    confirmButton: settings?.html?.buttons?.primary,
                    cancelButton: settings?.html?.buttons?.secondary,
                },
            };

            const { isConfirmed, } = await Swal.fire(swalProperties)
            if (isConfirmed) {
                await calculateRates({
                    items_: items,
                    rate: formData?.rate,
                    subMethod: currentMethod,
                });
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    };

    const calculateRates = async ({
        items_ = [],
        rate = 0.00,
        subMethod = '',
    }) => {
        const currentMethod = 'calculateRates';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true, btnCalculateRates: true }));

            //#region variables
            const itemIds_ = items.map((detail) => detail.id);
            //#endregion variables

            //#region update data (item)
            dataObj = {
                conditionals: [],
                ordersBy: [],
                method: settings?.mercadoLibre?.methods?.items?.calculateRates,
                items: itemIds_,
                rate: rate,
            };

            response = await ItemService.postQuery({
                token: auth?.account?.tokenVzLaML?.token,
                dataObj: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion update data (item)

            //#region get data (item)
            //#region get data (items)
            response = await getItemsByUser({
                e: null,
                showProcessing: false,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion get data (items)

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.<br/>`;
            response.msgText += `${itemIds_?.length}. ${labels?.items?.[languageObj?.id]}`;
            //#endregion get data (item)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, btnCalculateRates: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const sendItems = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'sendItems';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            e?.preventDefault();

            if (items.length <= 0) {
                response = getResponse({ type: 1, msgText_: messages?.thereIsNoDataToProcess?.[languageObj?.id] });
                return;
            }

            setProcess(prev => ({ ...prev, showLoading: true, btnSync: true }));

            //#region send items (api mercadoLibre)
            dataObj = {
                conditionals: [],
                ordersBy: [],
                userId: user.id,
                method: settings?.mercadoLibre?.methods?.items?.itemsSend,
            };

            response = await ItemService.postQuery({
                token: auth?.account?.tokenVzLaML?.token,
                dataObj: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion send items (api mercadoLibre)

            //#region get data (items)
            response = await getItemsByUser({
                e: e,
                showProcessing: false,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion get data (items)

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, btnSync: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion item (process)

    //#region item (edit)
    const getItemEdit = async ({
        id = '',
        description = '',
        rowIndex = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'getItemEdit';
        let response = getResponse({ type: 0 });
        try {
            if (itemEditShowModal === false) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                //#region get data (item)
                response = await ItemService.getById({
                    id: id,
                    token: auth?.account?.tokenVzLaML?.token,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion get data (item)

                setDtItemsIndex(rowIndex);
                setItemEdited(response.result);

                response = setDefaultItemEditFormData({
                    data: response?.result || {},
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;
                setItemEditShowModal(true);
            } else {
                setItemEditShowModal(false);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDefaultItemEditFormData = ({
        data = {
            listingTypeId: '',
            status: '',
        },
        subMethod = '',
    }) => {
        const currentMethod = 'setDefaultItemEditFormData';
        let response = getResponse({ type: 0 });
        try {
            setShowAlert(data?.listingTypeId === 'free' || data?.status === settings?.mercadoLibre?.status?.under_review);
            setShowAlertDelete(data?.status === settings?.mercadoLibre?.status?.deleted);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion item (edit)

    //#region rates (method)
    const getRates = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'getRates';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            setProcess(prev => ({ ...prev, showLoading: true, btnViewAllRates: true }));

            //#region variables
            let ratesLocal = [RateClass?.getClass()];
            //#endregion variables

            //#region get data (rates)
            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: user?.id, },
                ],
                ordersBy: [
                    { field: dbFields?.register, value: dbOrdersBy?.asc, },
                ],
                limit: 0,
            };

            response = await RateService.getAll({
                token: auth?.account?.tokenVzLaML?.token,
                dataObj: dataObj,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            ratesLocal = response?.result || [];
            //#endregion get data (rates)

            //#region set rates
            if (!isUndNullEmpNew({ data: ratesLocal, subMethod: currentMethod })?.result && ratesLocal.length > 0) {
                response = setRatesVariations({
                    data: ratesLocal,
                    // languageId: languageObj?.id,
                    languageObj: languageObj,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                ratesLocal = response.result;
            }
            //#endregion set rates

            setRateViews(ratesLocal);
            setRatesViewShowModal(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, btnViewAllRates: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getRateAdd = async ({
        e = {},
        userId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'getRateAdd';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            setProcess(prev => ({ ...prev, showLoading: true, btnRateAdd: true }));

            setApplyTo(0);
            setModalType(0);

            userId = isUndNullEmpNew({ data: userId, subMethod: currentMethod, })?.result ? $(`#${selUsersId}`).val() : userId;
            let rate_ = RateClass?.getClass();
            rate_.id = uuidv4();
            rate_.userId = userId;
            setRate(rate_);

            await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
            setShowModalRateAdd(true);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, btnRateAdd: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion rates (method)

    //#region process (others)
    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion process (others)

    return (
        <div>
            <Menu viewName={'items'} process={'process'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.items?.[languageObj?.id]} ({labels?.process?.[languageObj?.id]})
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.items?.[languageObj?.id]} ({labels?.process?.[languageObj?.id]})</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.account?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.info} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.account?.[languageObj?.id]}</h5>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body px-4 pb-0'>
                                        <div className='row'>
                                            {/* Select User */}
                                            <div className='col-12 col-md-4 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.user?.[languageObj?.id] || 'User'}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                            id={selUsersId}
                                                            onChange={(e) => getUserAndRateByUserId({ userId: e?.target?.value, showMessage: true, subMethod: 'selectUsers' })}>
                                                            <option defaultValue value=''>{messages?.selectUser?.[languageObj?.id]}</option>
                                                            {users?.length > 0 ?
                                                                users.map((user) => (
                                                                    <option key={user.id} value={user.id}>{` ${user.userName}`}</option>
                                                                ))
                                                                : null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* First Name */}
                                            <div className='col-12 col-md-4 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.firstName?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                            placeholder={labels?.firstName?.[languageObj?.id]}
                                                            value={formData?.firstName || ''}
                                                            title={labels?.firstName?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Last Name */}
                                            <div className='col-12 col-md-4 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.lastName?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                            placeholder={labels?.lastName?.[languageObj?.id]}
                                                            value={formData?.lastName || ''}
                                                            title={labels?.lastName?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            {/* Second ID */}
                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.secondId?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.idCard} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                            placeholder={labels?.secondId?.[languageObj?.id]}
                                                            value={formData?.secondId || 0}
                                                            title={labels?.secondId?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Email */}
                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.email?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light'
                                                            placeholder={labels?.email?.[languageObj?.id]}
                                                            value={formData?.email || ''}
                                                            title={labels?.email?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Rate */}
                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.rate?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.chartBar} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light text-right'
                                                            placeholder={labels?.rate?.[languageObj?.id]}
                                                            value={setSeparatorsNumbersNew({ number: formData?.rate || 0, withDecimals: true, subMethod: currentMethod })?.result}
                                                            title={labels?.rate?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Items Count */}
                                            <div className='col-12 col-md-3 mb-3'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                        {labels?.items?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon bg-light text-right'
                                                            placeholder={labels?.items?.[languageObj?.id]}
                                                            value={setSeparatorsNumbersNew({ number: items.length, withDecimals: false, subMethod: currentMethod })?.result}
                                                            title={labels?.items?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Consolidated Action Buttons */}
                                    <div className='card-footer border-0 bg-white px-4 pb-4 d-flex flex-column flex-md-row justify-content-md-end align-items-stretch align-items-md-center' style={{ gap: '8px' }}>
                                        <button className='btn btn-general border shadow-sm font-weight-bold px-4 text-secondary'
                                            disabled={!isSelected || process?.btnSeeItems}
                                            data-title={labels?.seeItems?.[languageObj?.id]}
                                            onClick={(e) => getItemsByUser({ e: e, showProcessing: true, subMethod: 'btnSeeItems', })}>
                                            <i className={(process?.btnSeeItems ? icons?.fasFa?.syncSpin : icons?.fasFa?.cloudDownloadAlt) + ' mr-2'}></i>
                                            {labels?.seeItems?.[languageObj?.id]}
                                        </button>
                                        <button className='btn btn-general border shadow-sm font-weight-bold px-4 text-secondary'
                                            disabled={!isSelected || process?.btnSync}
                                            data-title={labels?.synchronizeItems?.[languageObj?.id]}
                                            onClick={(e) => sendItems({ e: e, subMethod: 'btnSync' })}>
                                            <i className={(process?.btnSync ? icons?.fasFa?.syncSpin : icons?.fasFa?.cloudUploadAlt) + ' text-primary mr-2'}></i>
                                            {labels?.synchronizeItems?.[languageObj?.id]}
                                        </button>
                                        <button className='btn btn-general border shadow-sm font-weight-bold px-4 text-secondary'
                                            disabled={!isSelected || process?.btnRateAdd}
                                            data-title={labels?.addNewRate?.[languageObj?.id]}
                                            onClick={(e) => getRateAdd({ e: e, userId: '', subMethod: 'btnRateAdd', })}>
                                            <i className={(process?.btnRateAdd ? icons?.fasFa?.syncSpin : icons?.fasFa?.plusCircle) + ' text-success mr-2'}></i>
                                            {labels?.addNewRate?.[languageObj?.id]}
                                        </button>
                                        <button className='btn btn-general border shadow-sm font-weight-bold px-4 text-secondary'
                                            disabled={!isSelected || process?.btnViewAllRates}
                                            data-title={labels?.viewAllRates?.[languageObj?.id]}
                                            onClick={(e) => isSelected ? getRates({ e: e, subMethod: 'btnViewAllRates', }) : e?.preventDefault()}>
                                            <i className={(process?.btnViewAllRates ? icons?.fasFa?.syncSpin : icons?.fasFa?.alignJustify) + ' text-info mr-2'}></i>
                                            {labels?.viewAllRates?.[languageObj?.id]}
                                        </button>
                                        <button className='btn btn-general border shadow-sm font-weight-bold px-4 text-secondary'
                                            disabled={!isSelected || process?.btnCalculateRates}
                                            data-title={labels?.calculateRates?.[languageObj?.id]}
                                            onClick={() => showCalculateRatesModal({ subMethod: 'btnCalculateRates', })}>
                                            <i className={(process?.btnCalculateRates ? icons?.fasFa?.syncSpin : icons?.fasFa?.calculator) + ' text-warning mr-2'}></i>
                                            {labels?.calculateRates?.[languageObj?.id]}
                                        </button>
                                    </div>
                                </div>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.details?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.comment} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.items?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body px-4 pb-4'>
                                        <TableIndex tableId={dtItemsId} languageObj={languageObj} />
                                    </div>
                                </div>

                                {/* {itemEditShowModal && (
                                    <ItemEdit processValues={{
                                        $,
                                        auth,
                                        dtId: dtItemsId,
                                        dtRowId: dtItemsIndex,
                                        showModal: itemEditShowModal,
                                        setShowModal: setItemEditShowModal,
                                        item: itemEdited,
                                        setItem: setItemEdited,
                                        setFormData,
                                        formData,
                                        setFormDataDefault,
                                        showAlert,
                                        setShowAlert,
                                        showAlertDelete,
                                        setShowAlertDelete,
                                    }} />
                                )}

                                {showModalRateAdd && (
                                    <RateAddEdit processValues={{
                                        $,
                                        auth,
                                        user,
                                        setUser,
                                        users,
                                        setUsers,
                                        rate,
                                        setRate,
                                        applyTo,
                                        setApplyTo,
                                        // rateAddEditDateTimeId,
                                        // modalId,
                                        showModal: showModalRateAdd,
                                        setShowModal: setShowModalRateAdd,
                                        type: modalType,
                                        setType: setModalType,
                                        formData,
                                        setFormData,
                                        dtId: dtItemsId,
                                        getNewPrice,
                                        setComparatorPrices,
                                        newPrice,
                                        formName: 'Items'
                                    }} />)}

                                {ratesViewShowModal && (
                                    <ViewAllRates processValues={{
                                        $,
                                        auth,
                                        user,
                                        dtId: dtRatesViewsId,
                                        rateViews,
                                        setRateViews,
                                        showModal: ratesViewShowModal,
                                        setShowModal: setRatesViewShowModal,
                                    }} />
                                )} */}

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {itemEditShowModal && (
                        <ItemEdit processValues={{
                            $,
                            auth,
                            dtId: dtItemsId,
                            dtRowId: dtItemsIndex,
                            showModal: itemEditShowModal,
                            setShowModal: setItemEditShowModal,
                            item: itemEdited,
                            setItem: setItemEdited,
                            setFormData,
                            formData,
                            setFormDataDefault,
                            showAlert,
                            setShowAlert,
                            showAlertDelete,
                            setShowAlertDelete,
                        }} />
                    )}

                    {showModalRateAdd && (
                        <RateAddEdit processValues={{
                            $,
                            auth,
                            user,
                            setUser,
                            users,
                            setUsers,
                            rate,
                            setRate,
                            applyTo,
                            setApplyTo,
                            // rateAddEditDateTimeId,
                            // modalId,
                            showModal: showModalRateAdd,
                            setShowModal: setShowModalRateAdd,
                            type: modalType,
                            setType: setModalType,
                            formData,
                            setFormData,
                            dtId: dtItemsId,
                            getNewPrice,
                            setComparatorPrices,
                            newPrice,
                            formName: 'Items'
                        }} />)}

                    {ratesViewShowModal && (
                        <ViewAllRates processValues={{
                            $,
                            auth,
                            user,
                            dtId: dtRatesViewsId,
                            rateViews,
                            setRateViews,
                            showModal: ratesViewShowModal,
                            setShowModal: setRatesViewShowModal,
                        }} />
                    )}
                </section>
                {/* /.content */}

            </div>
        </div>
    )
}